import React, { useState, useEffect } from 'react';
import { Box, Container, Typography, Grid, CircularProgress } from '@mui/material';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import toast from 'react-hot-toast';
import { Helmet } from 'react-helmet-async';

import { useNavigate } from 'react-router-dom';
import { useQueryClient } from 'react-query';

import EmptyState from '../components/empty-state';
import { Card } from '../sections/@dashboard/find-edifier';

import { getUserDetails } from '../utils';
import { useQueryGetUserInvitesList, useMutationModifyMeetingInvite } from '../hooks/react-query/useData';

const MeetingInvites = () => {
  const userDetails = getUserDetails();
  const navigate = useNavigate();
  const [meetingInvitePayload, setMeetingInvitePayload] = useState({});
  const queryClient = useQueryClient();

  const { data: invitesData, isFetching } = useQueryGetUserInvitesList(userDetails?.token, navigate, toast);

  const { isLoading: isMeetingStatusModifying, mutate: updateMeetingStatus } = useMutationModifyMeetingInvite(
    meetingInvitePayload,
    toast,
    userDetails?.token,
    setMeetingInvitePayload,
    navigate,
    queryClient
  );

  useEffect(() => {
    if (Object.keys(meetingInvitePayload).length > 0) {
      updateMeetingStatus();
    }
  }, [meetingInvitePayload]);


  const invitesList = invitesData?.data?.data;

  return (
    <Container maxWidth="xl" sx={{ p: '0 !important' }}>
      <Helmet>
        <title>Edifying Teachers | Meeting Invites</title>
      </Helmet>
      <Typography variant="h3" sx={{ mb: '5px', color: 'text.titles' }}>
        Meeting Invites
      </Typography>
      {isFetching && (
        <Box sx={{ width: '100%', textAlign: 'center', pt: '50px' }}>
          <CircularProgress />
        </Box>
      )}

      {invitesList?.length === 0 && !isFetching && (

        <EmptyState icon={MailOutlineIcon}
          title="No Meeting Invites"
          description="You don't have any meeting invites at the moment. When you receive invites, they'll appear here."
        />

      )}
      {/* {!isFetching && ( */}
      <Grid container spacing={'28.47px'} sx={{ mt: '31px' }}>
        {
          invitesList?.map((data, key) => (
            <Card
              key={key}
              data={data}
              index={1}
              isInviteCard
              setMeetingInvitePayload={setMeetingInvitePayload}
              meetingInvitePayload={meetingInvitePayload}
              isMeetingStatusModifying={isMeetingStatusModifying}
              userRole={userDetails?.role}
            />
          ))}
      </Grid>
    </Container>
  );
};

export default MeetingInvites;
